import * as React from 'react';

import * as styles from './authorSection.css';

export const AuthorSection = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['section']}>{props.children}</div>;
};
